import React from "react";
import { useTranslation } from "react-i18next";
import AudioEditorBootstrap from "./AudioEditorBootstrap";
import AudioEditorLoader from "./AudioEditorLoader";
import AudioEditorSidebar from "./AudioEditorSidebar";
import { AudioEditorProvider } from "../../../context/AudioEditorContext";
import AudioEditorTracksMixer from "./AudioEditorTrackMixer";
import AudioEditorToolbar from "./AudioEditorToolbar";
import styles from "./AudioEditor.module.css";
import pageStyles from "../../../pages/create/AudioEditing.module.css";

type AudioEditorProps = {
    /** When true, show page title in the left column so params align under the app header (Claude). */
    withPageHeader?: boolean;
    /** Audio to open the editor on, when arriving from Projects or Drafts. */
    bootstrapAudioAIId?: string | null;
};

const AudioEditor = ({ withPageHeader = false, bootstrapAudioAIId = null }: AudioEditorProps) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <AudioEditorProvider>
            <AudioEditorBootstrap audioAIId={bootstrapAudioAIId} />
            <div className={`${styles.root}${withPageHeader ? ` ${styles.rootWithHeader}` : ""}`}>
                <div className={styles.container}>
                    <div className={styles.leftSection}>
                        {withPageHeader && (
                            <header className={pageStyles.head}>
                                <h1>{t("audioEditing")}</h1>
                                <p>{t("audioEditingSubtitle")}</p>
                            </header>
                        )}
                        <AudioEditorLoader />
                        <AudioEditorToolbar />
                        <AudioEditorTracksMixer />
                    </div>
                    <AudioEditorSidebar />
                </div>
            </div>
        </AudioEditorProvider>
    );
};

export default AudioEditor;
